import { Close, Edit } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { StyledErroresConectividadCardDetail } from "../../../../../styled/connectivity";

const ErroresConectividadCardDetail = ({
  news,
  handleOpenDetail,
  selectedDocument,
  desestimarErrorConectividad,
}) => {
  return (
    <StyledErroresConectividadCardDetail.Paper>
      <div>
        <Typography>
          {news.fechaHoraProcesada
            ? moment(news.fechaHoraProcesada).format("DD/MM/YYYY")
            : ""}
        </Typography>
        <Typography>
          <strong>Observación:</strong> {news.observaciones}
        </Typography>
      </div>
      {
        news.error === true && (
          <StyledErroresConectividadCardDetail.ActionsContainer>
            <Tooltip arrow title="Editar">
              <StyledErroresConectividadCardDetail.Icon>
                <Edit onClick={() => handleOpenDetail(selectedDocument, news)} />
              </StyledErroresConectividadCardDetail.Icon>
            </Tooltip>
            <Tooltip arrow title="Desestimar">
              <StyledErroresConectividadCardDetail.Icon>
                <Close onClick={() => desestimarErrorConectividad(news)} />
              </StyledErroresConectividadCardDetail.Icon>
            </Tooltip>
          </StyledErroresConectividadCardDetail.ActionsContainer>
        )
      }
    </StyledErroresConectividadCardDetail.Paper>
  );
};

export default ErroresConectividadCardDetail;
